import React from 'react';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Link,
  Typography,
  Button,
} from '@material-ui/core';

import * as actions from '../../../redux/actions';
import BaseAuthPage from '../BaseAuthPage';
import BaseCard from '../BaseCard';

type VerifyYourEmailProps = {
    sendEmailVerificationEmail: (...args: any[]) => any;
};

const VerifyYourEmail = (props: VerifyYourEmailProps) => {
  const email = localStorage.getItem('email');
  const footer = (
    <Typography variant="body2">
      Need help?&nbsp;
      <Link
        component={RouterLink}
        to="/login"
        variant="body2"
        color="textSecondary"
      >
        Contact us
      </Link>
    </Typography>
  );

  return (
    <BaseAuthPage title="Verify your email">
      <BaseCard
        title="Verify your email"
        footer={footer}
      >
        <Box my={2}>
          <Typography variant="subtitle1">
            We sent an email to
            {' '}
            <b>{email}</b>
          </Typography>
        </Box>
        <Box my={2}>
          <Typography>
            {/* eslint-disable-next-line max-len */}
            Just click on the link in that email to complete your signup. If you don't see it, you may need to <b>check your spam</b> folder.
          </Typography>
        </Box>
        <Box my={2}>
          <Typography>
            Still can't find the email?
          </Typography>
        </Box>
        <Box my={2}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => props.sendEmailVerificationEmail(email)}
          >
            Resend email
          </Button>
        </Box>
      </BaseCard>
    </BaseAuthPage>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  sendEmailVerificationEmail: (email: any, formActions?: any) => dispatch(actions.sendEmailVerificationEmail(email, formActions))
});

export default connect(null, mapDispatchToProps)(VerifyYourEmail);
